import registerCidadao from "@/app/actions/register-cidadao";
import { useUser } from "@/providers";
import { useCidadao } from "@/providers/cidadao-provider";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const schema = z.object({
  email: z
    .string({ message: "Por favor, preencha o campo." })
    .email({ message: "Por favor, insira um e-mail válido." }),
});

type TFormProps = z.infer<typeof schema>;
export const ONBOARDING_MODAL_KEY = "onboarding-modal";
export const CIDADAO_STORAGE_KEY = "cidadao_usr";

export function useOnboardingController() {
  const { isModalOpen, setIsModalOpen, cidadao, isLoading, setStoredCidadao } = useCidadao();
  const { userPending } = useUser();

  useEffect(() => {
    if (!!cidadao || isLoading || userPending) return;
    setIsModalOpen(true);
  }, [cidadao, isLoading, userPending]);

  const closeModal = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const {
    control,
    reset,
    handleSubmit: hookFormSubmit,
    setError,
    formState,
  } = useForm<TFormProps>({
    resolver: zodResolver(schema),
  });

  const { isPending, mutateAsync } = useMutation({
    mutationFn: registerCidadao,
    onSuccess: async (_data, variables) => {
      const email = variables.email;
      localStorage.setItem(CIDADAO_STORAGE_KEY, btoa(email));
      setStoredCidadao(email);
      closeModal();
      reset();
    },
    onError: (error: unknown) => {
      setError("email", {
        message:
          error instanceof Error
            ? error.message
            : "Ocorreu um erro ao cadastrar o e-mail.",
      });
    },
  });

  const onSubmit = hookFormSubmit(async ({ email }) => {
    await mutateAsync({
      email,
      id_gov: email,
      nome: "",
    });
  });

  return {
    isModalOpen,
    setIsModalOpen,
    onSubmit,
    control,
    formState,
    isPending,
  };
}
